/* 🤖 this file was generated by svg-to-ts*/
export const icoDatabase: {
  name: 'database';
  data: string;
} = {
  name: 'database',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 18V6c0-2.168-3.663-4-8-4S4 3.832 4 6v12c0 2.168 3.663 4 8 4s8-1.832 8-4zM12 4c3.691 0 5.931 1.507 6 1.994C17.931 6.493 15.691 8 12 8S6.069 6.493 6 6.006C6.069 5.507 8.309 4 12 4zM6 9.607C7.479 10.454 9.637 11 12 11s4.521-.546 6-1.393v2.387c-.069.499-2.309 2.006-6 2.006s-5.931-1.507-6-2V9.607zM6 18v-2.393C7.479 16.454 9.637 17 12 17s4.521-.546 6-1.393v2.387c-.069.499-2.309 2.006-6 2.006s-5.931-1.507-6-2z" fill="#909090"/></svg>`
};
